import { formatCurrency } from '@/lib/utils';

type Props = {
  ledgerTotalCents: number;
  materializedDriftCents: number;
};

function formatSignedCurrency(cents: number): string {
  const amount = Math.abs(cents) / 100;
  const prefix = cents < 0 ? '-' : '';
  return `${prefix}${formatCurrency(amount)}`;
}

export function BalanceHealthPanel({ ledgerTotalCents, materializedDriftCents }: Props) {
  const balanced = ledgerTotalCents === 0 && materializedDriftCents === 0;

  return (
    <div
      role="status"
      aria-label={`Ledger Health: ${balanced ? 'Balanced' : 'Drift detected'}`}
      className={`rounded-[1rem] border p-4 flex items-center gap-3 ${
        balanced
          ? 'bg-aura-primary/[0.08] border-aura-primary/15'
          : 'bg-red-50 border-red-200'
      }`}
    >
      <div
        className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-lg font-black ${
          balanced
            ? 'bg-gradient-to-br from-aura-primary to-aura-primary-dim text-on-primary'
            : 'bg-gradient-to-br from-status-error to-red-700 text-white'
        }`}
        aria-hidden="true"
      >
        {balanced ? '✓' : '!'}
      </div>
      <div className="min-w-0 flex-1">
        <div
          className={`text-[10px] font-black uppercase tracking-[0.15em] ${
            balanced ? 'text-aura-primary/60' : 'text-red-600/70'
          }`}
        >
          Ledger Health
        </div>
        <div
          className={`text-lg font-black tracking-tight ${
            balanced ? 'text-aura-primary' : 'text-status-error'
          }`}
        >
          {balanced
            ? `Balanced — ${formatCurrency(0)}`
            : `Drift: ${formatSignedCurrency(materializedDriftCents)}`}
        </div>
        {!balanced && (
          <div className="mt-0.5 text-xs font-semibold text-red-600/60">
            Ledger total: {formatSignedCurrency(ledgerTotalCents)} &middot; Materialized drift: {formatSignedCurrency(materializedDriftCents)}
          </div>
        )}
      </div>
    </div>
  );
}
